import React from 'react';
import { MyAccessibleDoctor } from '../../../bridge/types/doctorProfile';
import DoctorTile from './DoctorTile';
import SearchBarComponentUi from './SearchBarComponent';

const DoctorSearch = ({
    inputValue,
    setInputValue,
    list = [],
    setSelectedDoctor,
    selectedDoctor,
}: {
    list: MyAccessibleDoctor[];
    inputValue: string;
    selectedDoctor: MyAccessibleDoctor | undefined;
    setInputValue: React.Dispatch<React.SetStateAction<string>>;
    setSelectedDoctor: (doctor: MyAccessibleDoctor | undefined) => void;
}): JSX.Element => {
    return (
        <div className="dr-w-250 overflow-hidden rounded-b-8">
            <SearchBarComponentUi
                className="rounded-8 border-transparent"
                placeholder="Search Doctor"
                onChange={(e) => {
                    setInputValue(e.target.value);
                }}
                inputValue={inputValue}
            />
            <div className="h-1 w-full bg-darwin-neutral-200"></div>
            <div className="dr-max-h-1/2 overflow-y-scroll">
                {list.map((doctor) => (
                    <DoctorTile
                        isSelected={selectedDoctor?.id === doctor.id}
                        onClick={() => setSelectedDoctor(doctor)}
                        key={doctor.id}
                        doctor={doctor}
                    />
                ))}
            </div>
        </div>
    );
};

export default DoctorSearch;
